<div class="custom-box">
  <div class="header-special-request flex-center">
    <div class="columns mb-1pt is-vcentered">
      <div class="column is-narrow pb-2 pr-1">
        <em *ngIf="!passenger" class="mdi mdi-star has-text-grey mdi-18px" aria-hidden="true"></em>
        <em
          *ngIf="passenger"
          class="mdi mdi-account has-text-grey mdi-18px"
          aria-hidden="true"
        ></em>
      </div>
      <div class="column pl-0 weight-medium is-size-6">
        <span *ngIf="passenger" class="is-capitalized">{{ passenger }} </span>
        <span *ngIf="showBoth"> - </span>
        <span *ngIf="!passenger || showBoth">{{
          specialRequest?.code + ' - ' + specialRequest?.name
        }}</span>
      </div>
    </div>
    <div *ngIf="showComparison" class="flex-column">
      <span *ngIf="!(isAirline$ | async) && specialRequest?.validation?.diffAmount > 0">
        {{ 'ancillaries.diff-amount' | translate }}
        {{
          specialRequest?.validation?.diffAmount | currency : specialRequest?.validation?.currency : 'symbol' : '1.2-2' : 'en-US'
        }}
      </span>
    </div>
  </div>

  <div class="flex-column">
    <div class="flex-center">
      <span> {{ 'special-requests.request-state' | translate }}:&nbsp; </span>

      <div ngSwitch="{{ specialRequest.status | lowercase }}">
        <span
          attr.data-title="{{
            'special-requests.' + specialRequest.status | lowercase | translate
          }}"
        >
          <em
            *ngSwitchCase="requestState.Confirmed"
            class="mdi mdi-check-circle has-text-primary mdi-18px"
            content
          ></em>
          <em
            *ngSwitchCase="requestState.Denied"
            class="mdi mdi-close-circle has-text-danger mdi-18px"
            content
          ></em>
          <em
            *ngSwitchCase="requestState.Rejected"
            class="mdi mdi-close-circle has-text-danger mdi-18px"
            content
          ></em>
          <em
            *ngSwitchCase="requestState.Pending"
            class="mdi mdi-minus-circle mdi-18px has-text-warning"
            content
          ></em>
          <em
            *ngSwitchCase="requestState.NotDefined"
            class="mdi mdi-help-circle has-text-link mdi-18px"
            content
          ></em>
        </span>

        <span class="weight-medium">
          {{
            'special-requests.' + (specialRequest.status | lowercase) | translate | firstcase
          }}</span
        >
      </div>
    </div>
    <div>
      <span class="weight-medium"> {{ specialRequest.freeText }}</span>
    </div>
    <div *ngIf="SRTypes.ancillarie === type">
      {{ 'ancillaries.quantity' | translate }}{{ specialRequest.quantity }}
    </div>

    <div class="v-separator"></div>
    <div class="line-separator"></div>
    <div class="v-separator"></div>

    <div *ngIf="type == SRTypes.ancillarie" class="w-100">
      <span> {{ 'special-requests.coupons.info' | translate }}: </span>
      <br />

      <div *ngIf="specialRequest?.coupons?.length > 0">
        <div class="v-separator"></div>

        <div class="columns is-size-6 has-text-grey">
          <div class="column is-2">{{ 'special-requests.coupons.table.index' | translate }}</div>
          <div class="column is-3">{{ 'special-requests.coupons.table.number' | translate }}</div>
          <div class="column is-2">{{ 'special-requests.coupons.table.type' | translate }}</div>
          <div class="column is-3">{{ 'special-requests.coupons.table.status' | translate }}</div>
        </div>

        <!-- Body -->
        <div
          class="columns is-vcentered is-size-6 mb-1pt"
          *ngFor="let coupon of specialRequest?.coupons"
        >
          <div class="column is-2 weight-medium">
            {{ coupon.emdcouponindex }}
          </div>

          <div class="column is-3">
            {{ coupon.emdnumber }}
          </div>

          <div class="column is-2">
            {{ coupon.emdtype }}
          </div>

          <div class="column is-3 weight-medium">
            {{ coupon.emdstatus }}
          </div>
        </div>
      </div>
      <div *ngIf="specialRequest?.coupons?.length <= 0">
        <div class="alert alert-warning text-center" role="alert">
          {{ 'special-requests.coupons.missing' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="gray" *ngIf="specialRequest?.flights?.length === 0">
    <app-title
      class="is-block has-text-centered"
      [medium]="true"
      title="{{ 'special-requests.not-flights-info' | translate }}"
    >
    </app-title>
  </div>

  <!-- Header -->
  <div *ngIf="specialRequest?.flights?.length > 0">
    {{ 'special-requests.flights-info' | translate }}:
    <br />

    <div class="v-separator"></div>

    <div class="columns is-size-6 has-text-grey">
      <div class="column is-2">
        {{ 'special-requests.flight-number' | translate }}
      </div>
      <div class="column is-3">
        {{ 'special-requests.flight-departure' | translate }}
      </div>
      <div class="column is-2">
        {{ 'special-requests.flight-destiny' | translate }}
      </div>
      <div class="column is-3">
        {{ 'special-requests.flight-departure-date' | translate }}
      </div>
      <div class="column is-1"></div>
    </div>

    <!-- Body -->
    <div
      class="columns is-vcentered is-size-6 mb-1pt"
      *ngFor="let flight of specialRequest?.flights"
    >
      <div class="column is-2 weight-medium">
        {{ flight.flightNumber || uppercase }}
      </div>

      <div class="column is-3">
        {{ flight.departureCity }}
      </div>

      <div class="column is-2">
        {{ flight.arrivalCity }}
      </div>

      <div class="column is-3">
        {{ flight.departureDate | customDate | date | localizedDate : 'EEE dd MMM y ' : '+0000' }}
      </div>
      <div class="column is-1">
        {{ flight.departureDate | date : 'HH:mm' }}
      </div>
    </div>
  </div>

  <!-- Special Request Validation -->
  <div *ngIf="showSRequestValidation">
    <div class="line-separator"></div>
    <div class="v-separator"></div>
    <div class="v-separator"></div>

    <div class="special-request-validation-container">
      <div class="weight-medium">{{ 'ancillaries.compatibility' | translate }}:&nbsp;</div>

      <div *ngIf="sRequestValidationError">
        {{ 'ancillaries.api-error' | translate }}
        <em class="mdi mdi-close-circle has-text-danger mdi-18px"></em>
      </div>

      <div *ngIf="!sRequestValidationError">
        <div *ngIf="!sRequestValidationReady">
          <em class="mdi mdi-loading mdi-spin mdi-18px"></em>
        </div>
        <div *ngIf="sRequestValidationReady && isCompatible">
          {{ 'ancillaries.compatible' | translate }}
          <em class="mdi mdi-check-circle has-text-primary mdi-18px"></em>
        </div>
        <div *ngIf="sRequestValidationReady && !isCompatible">
          {{ 'ancillaries.incompatible' | translate }}
          <em class="mdi mdi-close-circle has-text-danger mdi-18px"></em>
        </div>
      </div>
    </div>
  </div>
  <!-- End Special Request Validation -->
</div>
